import { fetchContractLink, fetchAdditionalContractLink } from '../../../services/api/file';

export const contract = {
    namespaced: true,
    state: {
        main: '',
        additional: '',
    },
    mutations: {
        saveLink(state, data) {
            state.main = '/userfiles/' + data;
        },
        saveAdditionalLink(state, data) {
            state.additional = '/userfiles/' + data;
        }
    },
    actions: {
        fetchContractLink({ commit, dispatch }) {
            return fetchContractLink()
                .then((res) => {
                    commit('saveLink', res.data);
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    return Promise.reject(res);
                });
        },
        fetchAdditionalContractLink({ commit, dispatch }, tariff) {
            return fetchAdditionalContractLink(tariff)
                .then((res) => {
                    commit('saveAdditionalLink', res.data);
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    return Promise.reject(res);
                });
        }
    },
}


// WEBPACK FOOTER //
// ./src/modules/home/contract/store.js